<template>
  <!-- Shaft cross section -->
  <div :class="joinClasses('definition-layout__right-content', modifiers)">
    <div v-if="shaftDiagramVisible" class="diagram">
      <ShaftDiagram
        v-if="shaftDiagramData"
        :elements="shaftDiagramData.elements"
        :shape="shaftDiagramData.shape"
        :activeItem="shaftDiagramData.activeItem"
        :minMax="minMax"
        @updateActiveElement="updateElement"
        definition
      />
    </div>
  </div>
</template>

<script setup>
import ShaftDiagram from '@/components/shafts/shaft_diagram.vue';
import joinClasses from '@/functions/join_classes';

defineProps({
  elementType: { type: String, required: true },
  shaftDiagramData: { type: Object, required: false, default: null },
  shaftDiagramVisible: { type: Boolean, default: false },
  modifiers: { type: Array, default: () => [] },
  minMax: { type: Object, required: false, default: null },
});

const emit = defineEmits(['updateElementPosition']);

function updateElement(data) {
  emit('updateElementPosition', data);
}
</script>

<style lang="scss" scoped>
@import "@/stylesheets/global";
</style>
